var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('empty-table-icon'),_c('p',{staticClass:"text-center text-sm"},[_vm._v(_vm._s(_vm.description)+"!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }